import React, { useState } from 'react'
import MainHeader from './MainHeader'
import NavBar    from './NavBar'

/**
 * Header — composes TopBar, MainHeader, and NavBar.
 * Manages mobile drawer state locally and passes handlers down.
 */
const Header: React.FC = () => {
  const [mobileOpen, setMobileOpen] = useState(false)

  return (
    <>
     
      <MainHeader onMenuToggle={() => setMobileOpen(true)} />
      <NavBar
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />
    </>
  )
}

export default Header

